export default function PasswordSuccess() {
  return (
    <div className="card card--success">
      <div className="card-icon card-icon--success">&#10003;</div>
      <h2>Email Inviata!</h2>
      <p>
        Abbiamo preso in carico la tua richiesta. La password per sbloccare
        il documento è stata inviata nuovamente al tuo indirizzo email.
      </p>
      <p style={{ marginTop: '1rem' }}>
        Potrebbero volerci alcuni minuti per il recapito.
      </p>
      <div className="card-note">
        Se non ricevi nulla entro 15 minuti, contatta il supporto tecnico.
      </div>
    </div>
  );
}
